import { FunctionComponent } from 'react'
import { useIsPowerUser } from '../hooks/authHooks'

export const PowerUserView: FunctionComponent = ({ children }) => {
  const isAdmin = useIsPowerUser()

  if (!isAdmin) return null

  return <>{children}</>
}
